module.exports = __webpack_public_path__ + "img/bolivia.31ca478.webp";